import { useCurrentUser } from 'api/authentication/hooks';

import { MAX_VISIBLE_PRESENCE_AVATARS } from './constants';
import { UserAvatarList } from './user-avatar-list';

import { ActiveUser } from '../hooks/use-journey-presence';

type JourneyPresenceIndicatorProps = {
  activeUsers: ActiveUser[];
};

export const JourneyPresenceIndicator = ({ activeUsers }: JourneyPresenceIndicatorProps) => {
  const currentUser = useCurrentUser();
  if (!currentUser) {
    return null;
  }

  const currentUserId = currentUser.shortId;
  const otherUsers = activeUsers.filter((user) => user.userId !== currentUserId.toString());

  return (
    <UserAvatarList
      users={otherUsers}
      maxVisible={MAX_VISIBLE_PRESENCE_AVATARS}
      tooltipPlacement="left"
    />
  );
};
